import { render, staticRenderFns } from "./IconHeader.vue?vue&type=template&id=a6cca916&scoped=true&"
import script from "./IconHeader.vue?vue&type=script&lang=js&"
export * from "./IconHeader.vue?vue&type=script&lang=js&"
import style0 from "./IconHeader.vue?vue&type=style&index=0&id=a6cca916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cca916",
  null
  
)

export default component.exports